export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10067.a76d340c.jpg";